import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { AD_UNIT_PATH_FRAGMENT } from './fragment'
import { Data, Variables } from './types'

export const GET_AD_UNIT_PATHS = (): TypedDocumentNode<Data, Variables> => gql`
  ${AD_UNIT_PATH_FRAGMENT()}

  query getAdUnitPaths($domainId: ID, $workspaceId: ID!) {
    adUnits(domainId: $domainId, workspaceId: $workspaceId) {
      nodes {
        ...AdUnitPathFragment
      }
    }
  }
`
